import { Chart } from "chart.js";
import { color } from "chart.js/helpers";
import { observer } from "mobx-react"
import { useEffect, useRef } from "react";

const Tokenomics = observer(() => {
    const chartRef = useRef(null);
    const imageRef = useRef(null);
    let lastScrollTop = 0;

    // Function to check if the element is in the viewport
    const isInViewport = (element) => {
        const rect = element.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    };

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (imageRef.current && isInViewport(imageRef.current)) {
                if (scrollTop > lastScrollTop) {
                    // Scrolling down
                    imageRef.current.classList.add("animate-down");
                    imageRef.current.classList.remove("animate-up");
                } else {
                    // Scrolling up
                    imageRef.current.classList.add("animate-up");
                    imageRef.current.classList.remove("animate-down");
                }
            } else if (imageRef.current) {
                // Reset when the element is out of view
                imageRef.current.classList.remove("animate-down", "animate-up");
            }

            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Ensure it doesn't go negative
        };

        window.addEventListener("scroll", handleScroll);

        // Cleanup on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []); // Run once after the component mounts

    useEffect(() => {
        if (chartRef.current) {
            const chart = new Chart(chartRef.current, {
                type: "pie",
                data: {
                    labels: [
                        "Community Rewards & Airdrops (15%)",
                        " Team Allocation (25%)",
                        " Liquidity Pool (40%)",
                        " Marketing & Partnerships (15%)",
                        "Development Reserve (5%)",
                    ],
                    datasets: [
                        {
                            data: [15, 25, 40, 15, 5],
                            backgroundColor: [
                                "#ff6384",
                                "#36a2eb",
                                "#ffce56",
                                "#4bc0c0",
                                "#9966ff",
                            ],
                            hoverOffset: 4,
                        },
                    ],
                },
                options: {
                    plugins: {
                        legend: {
                            display: false, // Completely disable the legend
                        },
                    },
                    responsive: true,
                },
            });

            // Cleanup on component unmount
            return () => chart.destroy();
        }
    }, []);
    return (<>
        <section className="tokenomics-section text-white py-5" id="tokenomics">
            <div className="container">
                <h2 className="weird-subtitle text-center">Tokenomics</h2>
                <div className="row mt-4 d-flex align-items-center">
                    <div className="col-md-4 animated-content show">
                        <p style={{ fontSize: "1.25rem" }}>
                            💰 <strong>Total Supply:</strong> 1 Billion SNOWBOLL
                        </p>
                        <p style={{ fontSize: "1.25rem" }}>
                            🔥<strong>Distribution Breakdown</strong>
                        </p>
                        <ul
                            style={{ fontSize: "1.25rem", listStyleType: "none", padding: 0 }}
                        >
                            <li style={{color:"#ff6384"}}>-Community Rewards & Airdrops (15%)</li>
                            <li style={{color:"#36a2eb"}}>- Team Allocation (25%)</li>
                            <li style={{color:"#ffce56"}}>- Liquidity Pool (40%)</li>
                            <li style={{color:"#4bc0c0"}}>- Marketing & Partnerships (15%)</li>
                            <li style={{color:"#9966ff"}}>- Development Reserve (5%)"</li>
                        </ul>
                    </div>
                    <div className="col-md-3 animated-content show" >
                        <canvas ref={chartRef} />
                    </div>
                    <div className="col-md-5 col-12 snow-bunny-img">
                        <img
                            ref={imageRef}
                            src="assets/img/snowball1.png"
                            className="image-animation img-fluid"
                            alt="MemeCoin image"
                        />
                    </div>
                </div>
            </div>
        </section>
    </>)
});

export default Tokenomics;